const countries = [
  { code: '93', name: 'Afghanistan', flag: '🇦🇫', phoneNumberLength: 9 },
  { code: '355', name: 'Albania', flag: '🇦🇱', phoneNumberLength: 9 },
  { code: '213', name: 'Algeria', flag: '🇩🇿', phoneNumberLength: 9 },
  { code: '1', name: 'United States', flag: '🇺🇸', phoneNumberLength: 10 },
  { code: '376', name: 'Andorra', flag: '🇦🇩', phoneNumberLength: 9 },
  { code: '244', name: 'Angola', flag: '🇦🇴', phoneNumberLength: 9 },
  { code: '1', name: 'Antigua and Barbuda', flag: '🇦🇬', phoneNumberLength: 10 },
  { code: '54', name: 'Argentina', flag: '🇦🇷', phoneNumberLength: 10 },
  { code: '374', name: 'Armenia', flag: '🇦🇲', phoneNumberLength: 8 },
  { code: '61', name: 'Australia', flag: '🇦🇺', phoneNumberLength: 9 },
  { code: '43', name: 'Austria', flag: '🇦🇹', phoneNumberLength: 10 },
  { code: '994', name: 'Azerbaijan', flag: '🇦🇿', phoneNumberLength: 9 },
  { code: '1', name: 'Bahamas', flag: '🇧🇸', phoneNumberLength: 10 },
  { code: '973', name: 'Bahrain', flag: '🇧🇭', phoneNumberLength: 8 },
  { code: '880', name: 'Bangladesh', flag: '🇧🇩', phoneNumberLength: 10 },
  { code: '1', name: 'Barbados', flag: '🇧🇧', phoneNumberLength: 10 },
  { code: '375', name: 'Belarus', flag: '🇧🇾', phoneNumberLength: 9 },
  { code: '32', name: 'Belgium', flag: '🇧🇪', phoneNumberLength: 9 },
  { code: '501', name: 'Belize', flag: '🇧🇿', phoneNumberLength: 7 },
  { code: '229', name: 'Benin', flag: '🇧🇯', phoneNumberLength: 9 },
  { code: '975', name: 'Bhutan', flag: '🇧🇹', phoneNumberLength: 8 },
  { code: '591', name: 'Bolivia', flag: '🇧🇴', phoneNumberLength: 8 },
  { code: '387', name: 'Bosnia and Herzegovina', flag: '🇧🇦', phoneNumberLength: 8 },
  { code: '267', name: 'Botswana', flag: '🇧🇼', phoneNumberLength: 8 },
  { code: '55', name: 'Brazil', flag: '🇧🇷', phoneNumberLength: 11 },
  { code: '673', name: 'Brunei', flag: '🇧🇳', phoneNumberLength: 7 },
  { code: '359', name: 'Bulgaria', flag: '🇧🇬', phoneNumberLength: 9 },
  { code: '226', name: 'Burkina Faso', flag: '🇧🇫', phoneNumberLength: 8 },
  { code: '257', name: 'Burundi', flag: '🇧🇮', phoneNumberLength: 9 },
  { code: '855', name: 'Cambodia', flag: '🇰🇭', phoneNumberLength: 9 },
  { code: '237', name: 'Cameroon', flag: '🇨🇲', phoneNumberLength: 9 },
  { code: '1', name: 'Canada', flag: '🇨🇦', phoneNumberLength: 10 },
  { code: '238', name: 'Cape Verde', flag: '🇨🇻', phoneNumberLength: 7 },
  { code: '236', name: 'Central African Republic', flag: '🇨🇫', phoneNumberLength: 8 },
  { code: '235', name: 'Chad', flag: '🇹🇩', phoneNumberLength: 9 },
  { code: '56', name: 'Chile', flag: '🇨🇱', phoneNumberLength: 9 },
  { code: '86', name: 'China', flag: '🇨🇳', phoneNumberLength: 11 },
  { code: '57', name: 'Colombia', flag: '🇨🇴', phoneNumberLength: 10 },
  { code: '269', name: 'Comoros', flag: '🇰🇲', phoneNumberLength: 7 },
  { code: '242', name: 'Congo (Brazzaville)', flag: '🇨🇬', phoneNumberLength: 9 },
  { code: '243', name: 'Congo (Kinshasa)', flag: '🇨🇩', phoneNumberLength: 9 },
  { code: '506', name: 'Costa Rica', flag: '🇨🇷', phoneNumberLength: 8 },
  { code: '225', name: 'Cote d\'Ivoire', flag: '🇨🇮', phoneNumberLength: 8 },
  { code: '385', name: 'Croatia', flag: '🇭🇷', phoneNumberLength: 9 },
  { code: '53', name: 'Cuba', flag: '🇨🇺', phoneNumberLength: 8 },
  { code: '357', name: 'Cyprus', flag: '🇨🇾', phoneNumberLength: 8 },
  { code: '420', name: 'Czech Republic', flag: '🇨🇿', phoneNumberLength: 9 },
  { code: '45', name: 'Denmark', flag: '🇩🇰', phoneNumberLength: 8 },
  { code: '253', name: 'Djibouti', flag: '🇩🇯', phoneNumberLength: 6 },
  { code: '1', name: 'Dominica', flag: '🇩🇲', phoneNumberLength: 10 },
  { code: '1', name: 'Dominican Republic', flag: '🇩🇴', phoneNumberLength: 10 },
  { code: '593', name: 'Ecuador', flag: '🇪🇨', phoneNumberLength: 9 },
  { code: '20', name: 'Egypt', flag: '🇪🇬', phoneNumberLength: 10 },
  { code: '503', name: 'El Salvador', flag: '🇸🇻', phoneNumberLength: 8 },
  { code: '240', name: 'Equatorial Guinea', flag: '🇬🇶', phoneNumberLength: 9 },
  { code: '291', name: 'Eritrea', flag: '🇪🇷', phoneNumberLength: 7 },
  { code: '372', name: 'Estonia', flag: '🇪🇪', phoneNumberLength: 8 },
  { code: '251', name: 'Ethiopia', flag: '🇪🇹', phoneNumberLength: 9 },
  { code: '679', name: 'Fiji', flag: '🇫🇯', phoneNumberLength: 7 },
  { code: '358', name: 'Finland', flag: '🇫🇮', phoneNumberLength: 10 },
  { code: '33', name: 'France', flag: '🇫🇷', phoneNumberLength: 9 },
  { code: '241', name: 'Gabon', flag: '🇬🇦', phoneNumberLength: 7 },
  { code: '220', name: 'Gambia', flag: '🇬🇲', phoneNumberLength: 7 },
  { code: '995', name: 'Georgia', flag: '🇬🇪', phoneNumberLength: 9 },
  { code: '49', name: 'Germany', flag: '🇩🇪', phoneNumberLength: 11 },
  { code: '233', name: 'Ghana', flag: '🇬🇭', phoneNumberLength: 9 },
  { code: '30', name: 'Greece', flag: '🇬🇷', phoneNumberLength: 10 },
  { code: '1', name: 'Grenada', flag: '🇬🇩', phoneNumberLength: 10 },
  { code: '502', name: 'Guatemala', flag: '🇬🇹', phoneNumberLength: 8 },
  { code: '224', name: 'Guinea', flag: '🇬🇳', phoneNumberLength: 9 },
  { code: '245', name: 'Guinea-Bissau', flag: '🇬🇼', phoneNumberLength: 7 },
  { code: '592', name: 'Guyana', flag: '🇬🇾', phoneNumberLength: 7 },
  { code: '509', name: 'Haiti', flag: '🇭🇹', phoneNumberLength: 8 },
  { code: '504', name: 'Honduras', flag: '🇭🇳', phoneNumberLength: 8 },
  { code: '852', name: 'Hong Kong', flag: '🇭🇰', phoneNumberLength: 8 },
  { code: '36', name: 'Hungary', flag: '🇭🇺', phoneNumberLength: 9 },
  { code: '354', name: 'Iceland', flag: '🇮🇸', phoneNumberLength: 7 },
  { code: '91', name: 'India', flag: '🇮🇳', phoneNumberLength: 10 },
  { code: '62', name: 'Indonesia', flag: '🇮🇩', phoneNumberLength: 11 },
  { code: '98', name: 'Iran', flag: '🇮🇷', phoneNumberLength: 10 },
  { code: '964', name: 'Iraq', flag: '🇮🇶', phoneNumberLength: 10 },
  { code: '353', name: 'Ireland', flag: '🇮🇪', phoneNumberLength: 9 },
  { code: '972', name: 'Israel', flag: '🇮🇱', phoneNumberLength: 9 },
  { code: '39', name: 'Italy', flag: '🇮🇹', phoneNumberLength: 10 },
  { code: '1', name: 'Jamaica', flag: '🇯🇲', phoneNumberLength: 10 },
  { code: '81', name: 'Japan', flag: '🇯🇵', phoneNumberLength: 10 },
  { code: '962', name: 'Jordan', flag: '🇯🇴', phoneNumberLength: 9 },
  { code: '7', name: 'Kazakhstan', flag: '🇰🇿', phoneNumberLength: 10 },
  { code: '254', name: 'Kenya', flag: '🇰🇪', phoneNumberLength: 10 },
  { code: '686', name: 'Kiribati', flag: '🇰🇮', phoneNumberLength: 8 },
  { code: '965', name: 'Kuwait', flag: '🇰🇼', phoneNumberLength: 8 },
  { code: '996', name: 'Kyrgyzstan', flag: '🇰🇬', phoneNumberLength: 9 },
  { code: '856', name: 'Laos', flag: '🇱🇦', phoneNumberLength: 9 },
  { code: '371', name: 'Latvia', flag: '🇱🇻', phoneNumberLength: 8 },
  { code: '961', name: 'Lebanon', flag: '🇱🇧', phoneNumberLength: 8 },
  { code: '266', name: 'Lesotho', flag: '🇱🇸', phoneNumberLength: 8 },
  { code: '231', name: 'Liberia', flag: '🇱🇷', phoneNumberLength: 7 },
  { code: '218', name: 'Libya', flag: '🇱🇾', phoneNumberLength: 9 },
  { code: '423', name: 'Liechtenstein', flag: '🇱🇮', phoneNumberLength: 9 },
  { code: '370', name: 'Lithuania', flag: '🇱🇹', phoneNumberLength: 8 },
  { code: '352', name: 'Luxembourg', flag: '🇱🇺', phoneNumberLength: 9 },
  { code: '853', name: 'Macau', flag: '🇲🇴', phoneNumberLength: 8 },
  { code: '389', name: 'North Macedonia', flag: '🇲🇰', phoneNumberLength: 8 },
  { code: '261', name: 'Madagascar', flag: '🇲🇬', phoneNumberLength: 9 },
  { code: '265', name: 'Malawi', flag: '🇲🇼', phoneNumberLength: 9 },
  { code: '60', name: 'Malaysia', flag: '🇲🇾', phoneNumberLength: 9 },
  { code: '960', name: 'Maldives', flag: '🇲🇻', phoneNumberLength: 7 },
  { code: '223', name: 'Mali', flag: '🇲🇱', phoneNumberLength: 8 },
  { code: '356', name: 'Malta', flag: '🇲🇹', phoneNumberLength: 8 },
  { code: '692', name: 'Marshall Islands', flag: '🇲🇭', phoneNumberLength: 7 },
  { code: '222', name: 'Mauritania', flag: '🇲🇷', phoneNumberLength: 8 },
  { code: '230', name: 'Mauritius', flag: '🇲🇺', phoneNumberLength: 8 },
  { code: '52', name: 'Mexico', flag: '🇲🇽', phoneNumberLength: 10 },
  { code: '691', name: 'Micronesia', flag: '🇫🇲', phoneNumberLength: 7 },
  { code: '373', name: 'Moldova', flag: '🇲🇩', phoneNumberLength: 8 },
  { code: '377', name: 'Monaco', flag: '🇲🇨', phoneNumberLength: 8 },
  { code: '976', name: 'Mongolia', flag: '🇲🇳', phoneNumberLength: 8 },
  { code: '382', name: 'Montenegro', flag: '🇲🇪', phoneNumberLength: 8 },
  { code: '212', name: 'Morocco', flag: '🇲🇦', phoneNumberLength: 9 },
  { code: '258', name: 'Mozambique', flag: '🇲🇿', phoneNumberLength: 9 },
  { code: '95', name: 'Myanmar', flag: '🇲🇲', phoneNumberLength: 9 },
  { code: '264', name: 'Namibia', flag: '🇳🇦', phoneNumberLength: 9 },
  { code: '674', name: 'Nauru', flag: '🇳🇷', phoneNumberLength: 7 },
  { code: '977', name: 'Nepal', flag: '🇳🇵', phoneNumberLength: 10 },
  { code: '31', name: 'Netherlands', flag: '🇳🇱', phoneNumberLength: 9 },
  { code: '64', name: 'New Zealand', flag: '🇳🇿', phoneNumberLength: 9 },
  { code: '505', name: 'Nicaragua', flag: '🇳🇮', phoneNumberLength: 8 },
  { code: '227', name: 'Niger', flag: '🇳🇪', phoneNumberLength: 8 },
  { code: '234', name: 'Nigeria', flag: '🇳🇬', phoneNumberLength: 10 },
  { code: '47', name: 'Norway', flag: '🇳🇴', phoneNumberLength: 8 },
  { code: '968', name: 'Oman', flag: '🇴🇲', phoneNumberLength: 8 },
  { code: '92', name: 'Pakistan', flag: '🇵🇰', phoneNumberLength: 10 },
  { code: '680', name: 'Palau', flag: '🇵🇼', phoneNumberLength: 7 },
  { code: '970', name: 'Palestine', flag: '🇵🇸', phoneNumberLength: 9 },
  { code: '507', name: 'Panama', flag: '🇵🇦', phoneNumberLength: 8 },
  { code: '675', name: 'Papua New Guinea', flag: '🇵🇬', phoneNumberLength: 8 },
  { code: '595', name: 'Paraguay', flag: '🇵🇾', phoneNumberLength: 9 },
  { code: '51', name: 'Peru', flag: '🇵🇪', phoneNumberLength: 9 },
  { code: '63', name: 'Philippines', flag: '🇵🇭', phoneNumberLength: 10 },
  { code: '48', name: 'Poland', flag: '🇵🇱', phoneNumberLength: 9 },
  { code: '351', name: 'Portugal', flag: '🇵🇹', phoneNumberLength: 9 },
  { code: '974', name: 'Qatar', flag: '🇶🇦', phoneNumberLength: 8 },
  { code: '242', name: 'Republic of the Congo', flag: '🇨🇬', phoneNumberLength: 9 },
  { code: '40', name: 'Romania', flag: '🇷🇴', phoneNumberLength: 9 },
  { code: '7', name: 'Russia', flag: '🇷🇺', phoneNumberLength: 10 },
  { code: '250', name: 'Rwanda', flag: '🇷🇼', phoneNumberLength: 9 },
  { code: '685', name: 'Samoa', flag: '🇼🇸', phoneNumberLength: 5 },
  { code: '378', name: 'San Marino', flag: '🇸🇲', phoneNumberLength: 10 },
  { code: '239', name: 'São Tomé and Príncipe', flag: '🇸🇹', phoneNumberLength: 7 },
  { code: '966', name: 'Saudi Arabia', flag: '🇸🇦', phoneNumberLength: 9 },
  { code: '221', name: 'Senegal', flag: '🇸🇳', phoneNumberLength: 9 },
  { code: '381', name: 'Serbia', flag: '🇷🇸', phoneNumberLength: 9 },
  { code: '248', name: 'Seychelles', flag: '🇸🇨', phoneNumberLength: 7 },
  { code: '232', name: 'Sierra Leone', flag: '🇸🇱', phoneNumberLength: 8 },
  { code: '65', name: 'Singapore', flag: '🇸🇬', phoneNumberLength: 8 },
  { code: '421', name: 'Slovakia', flag: '🇸🇰', phoneNumberLength: 9 },
  { code: '386', name: 'Slovenia', flag: '🇸🇮', phoneNumberLength: 8 },
  { code: '677', name: 'Solomon Islands', flag: '🇸🇧', phoneNumberLength: 7 },
  { code: '252', name: 'Somalia', flag: '🇸🇴', phoneNumberLength: 7 },
  { code: '27', name: 'South Africa', flag: '🇿🇦', phoneNumberLength: 9 },
  { code: '82', name: 'South Korea', flag: '🇰🇷', phoneNumberLength: 10 },
  { code: '211', name: 'South Sudan', flag: '🇸🇸', phoneNumberLength: 9 },
  { code: '34', name: 'Spain', flag: '🇪🇸', phoneNumberLength: 9 },
  { code: '94', name: 'Sri Lanka', flag: '🇱🇰', phoneNumberLength: 9 },
  { code: '249', name: 'Sudan', flag: '🇸🇩', phoneNumberLength: 9 },
  { code: '597', name: 'Suriname', flag: '🇸🇷', phoneNumberLength: 7 },
  { code: '268', name: 'Swaziland', flag: '🇸🇿', phoneNumberLength: 8 },
  { code: '46', name: 'Sweden', flag: '🇸🇪', phoneNumberLength: 9 },
  { code: '41', name: 'Switzerland', flag: '🇨🇭', phoneNumberLength: 9 },
  { code: '963', name: 'Syria', flag: '🇸🇾', phoneNumberLength: 9 },
  { code: '886', name: 'Taiwan', flag: '🇹🇼', phoneNumberLength: 9 },
  { code: '992', name: 'Tajikistan', flag: '🇹🇯', phoneNumberLength: 9 },
  { code: '255', name: 'Tanzania', flag: '🇹🇿', phoneNumberLength: 9 },
  { code: '66', name: 'Thailand', flag: '🇹🇭', phoneNumberLength: 9 },
  { code: '228', name: 'Togo', flag: '🇹🇬', phoneNumberLength: 8 },
  { code: '676', name: 'Tonga', flag: '🇹🇴', phoneNumberLength: 5 },
  { code: '1', name: 'Trinidad and Tobago', flag: '🇹🇹', phoneNumberLength: 10 },
  { code: '216', name: 'Tunisia', flag: '🇹🇳', phoneNumberLength: 8 },
  { code: '90', name: 'Turkey', flag: '🇹🇷', phoneNumberLength: 10 },
  { code: '993', name: 'Turkmenistan', flag: '🇹🇲', phoneNumberLength: 9 },
  { code: '688', name: 'Tuvalu', flag: '🇹🇻', phoneNumberLength: 5 },
  { code: '256', name: 'Uganda', flag: '🇺🇬', phoneNumberLength: 9 },
  { code: '380', name: 'Ukraine', flag: '🇺🇦', phoneNumberLength: 9 },
  { code: '971', name: 'United Arab Emirates', flag: '🇦🇪', phoneNumberLength: 9 },
  { code: '44', name: 'United Kingdom', flag: '🇬🇧', phoneNumberLength: 10 },
  { code: '1', name: 'United States', flag: '🇺🇸', phoneNumberLength: 10 },
  { code: '598', name: 'Uruguay', flag: '🇺🇾', phoneNumberLength: 8 },
  { code: '998', name: 'Uzbekistan', flag: '🇺🇿', phoneNumberLength: 9 },
  { code: '678', name: 'Vanuatu', flag: '🇻🇺', phoneNumberLength: 7 },
  { code: '379', name: 'Vatican City', flag: '🇻🇦', phoneNumberLength: 10 },
  { code: '58', name: 'Venezuela', flag: '🇻🇪', phoneNumberLength: 10 },
  { code: '84', name: 'Vietnam', flag: '🇻🇳', phoneNumberLength: 10 },
  { code: '967', name: 'Yemen', flag: '🇾🇪', phoneNumberLength: 9 },
  { code: '260', name: 'Zambia', flag: '🇿🇲', phoneNumberLength: 9 },
  { code: '263', name: 'Zimbabwe', flag: '🇿🇼', phoneNumberLength: 9 },
];   

export default countries;